'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Record = _interopRequireDefault(require("Icons/Record"));
var _Users = _interopRequireDefault(require("Icons/Users"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
let menu_configuration = {
  home: {
    CODE: 'UserHomePage',
    label: 'Accueil'
  },
  records: {
    CODE: 'AdminProjectsDashboard',
    label: 'Dossiers',
    icon: _Record.default
  },
  users: {
    CODE: 'AdminUsersDashboard',
    label: 'Utilisateurs',
    icon: _Users.default,
    hide_when: 'is_deltex'
  }
};
class BackHeader extends _react.Component {
  constructor() {
    var _app$state$session, _app$state$session$us;
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      loading: false,
      roles: ((_app$state$session = app.state.session) === null || _app$state$session === void 0 ? void 0 : (_app$state$session$us = _app$state$session.user) === null || _app$state$session$us === void 0 ? void 0 : _app$state$session$us.roles) || []
    });
    (0, _defineProperty2.default)(this, "initialized", false);
    (0, _defineProperty2.default)(this, "handleSessionChange", _ref => {
      var _app$state$session2, _app$state$session2$u;
      let {
        source,
        data = {}
      } = _ref;
      const component = this,
        props = this.props,
        state = this.state;
      if (!((_app$state$session2 = app.state.session) !== null && _app$state$session2 !== void 0 && (_app$state$session2$u = _app$state$session2.user) !== null && _app$state$session2$u !== void 0 && _app$state$session2$u.id)) return;
      component.setState({
        roles: app.state.session.user.roles || []
      });
      if (component.initialized === false) component.initMenu();
    });
    (0, _defineProperty2.default)(this, "initMenu", () => {
      const component = this,
        props = this.props,
        state = this.state;
      component.initialized = true;
      const configuration = (0, _cloneDeep2.default)(menu_configuration);
      Object.keys(configuration).forEach(function (name) {
        const infos = configuration[name];
        const link_url = infos.CODE ? (0, _Routing.URL)(infos.CODE) : infos.url;
        if (link_url === document.location.pathname) {
          configuration[name].active = true;
        }
        const active_sub_item = Object.keys(infos.sub_items || {}).find(function (name) {
          const item_url = infos.CODE ? (0, _Routing.URL)(infos.sub_items[name].CODE) : infos.sub_items[name].url;
          return document.location.pathname === item_url;
        });
        if (active_sub_item) {
          configuration[name].active = true;
          configuration[name].sub_items[active_sub_item].active = true;
        } else {
          const active_sub_item = Object.keys(infos.sub_items || {}).find(function (name) {
            const item_url = infos.CODE ? (0, _Routing.URL)(infos.sub_items[name].CODE) : infos.sub_items[name].url;
            return document.location.pathname.startsWith(item_url);
          });
          if (active_sub_item) {
            configuration[name].active = true;
            configuration[name].sub_items[active_sub_item].active = true;
          }
        }
      });
      component.setState({
        configuration: configuration
      });
    });
    (0, _defineProperty2.default)(this, "handleDocClick", _ref2 => {
      let {
        source,
        data = {}
      } = _ref2;
      const component = this,
        props = this.props,
        state = this.state;
      if (source === 'BackHeader') return;
      component.setState({
        open_dropdown: undefined
      });
    });
    (0, _defineProperty2.default)(this, "toggleDropDown", (e, name) => {
      const component = this,
        props = this.props,
        state = this.state;
      e.stopPropagation();
      app.emit({
        event: 'documentClick',
        source: 'BackHeader'
      });
      component.setState({
        open_dropdown: state.open_dropdown !== name ? name : undefined
      });
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'documentClick',
      cb: component.handleDocClick
    });
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    component.handleSessionChange({});
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'documentClick',
      cb: component.handleDocClick
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const is__deltex = state.roles.includes('deltex');
    const hide_conditions = {
      is_deltex: is__deltex === false
    };
    const items = Object.keys(state.configuration || {}).filter(function (name) {
      const infos = state.configuration[name];
      const is__hidden = infos.hide_when ? hide_conditions[infos.hide_when] || false : false;
      return is__hidden ? false : true;
    }).map(function (name) {
      const infos = state.configuration[name];
      const link_url = infos.CODE ? (0, _Routing.URL)(infos.CODE) : infos.url;
      let modifiers = infos.active === true ? ['active'] : [];
      let onClick;
      if (infos.sub_items) {
        modifiers.push('dropdown');
        onClick = e => component.toggleDropDown(e, name);
        if (state.open_dropdown === name) modifiers.push('open');
      }
      const sub_items = Object.keys(infos.sub_items || {}).filter(function (name) {
        const item = infos.sub_items[name];
        const is__hidden = item.hide_when ? hide_conditions[item.hide_when] || false : false;
        return is__hidden ? false : true;
      }).map(function (name) {
        const item = infos.sub_items[name];
        let class_name = 'c-menu-item__subitem';
        if (item.active === true) class_name += ' active';
        const Icon = item.icon;
        const item_icon = Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
          className: "c-menu-item__subitem-icon"
        }) : undefined;
        const item_url = item.CODE ? (0, _Routing.URL)(item.CODE) : item.url;
        let output = /*#__PURE__*/_react.default.createElement("li", {
          className: class_name,
          key: item_url
        }, item_icon, /*#__PURE__*/_react.default.createElement(_Link.default, {
          className: 'c-menu-item__subitem-link',
          href: item_url,
          rel: "noopener noreferrer"
        }, item.label));
        return output;
      });
      const Icon = infos.icon;
      const icon = Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
        className: "c-menu-item__icon"
      }) : undefined;
      const link_element = modifiers.includes('active') && !sub_items.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "c-menu-item__link"
      }, icon, infos.label) : /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "c-menu-item__link",
        onClick: onClick,
        href: onClick ? undefined : link_url,
        rel: "noopener noreferrer",
        component: _Link.default
      }, icon, infos.label);
      let output = /*#__PURE__*/_react.default.createElement("li", {
        className: (0, _bemit.default)('c-menu-item', modifiers),
        key: link_url
      }, link_element, sub_items.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", {
        role: "menu",
        className: "c-menu-item__menu"
      }, sub_items) : undefined);
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("nav", {
      className: "o-header__admin-navbar"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "o-header__admin-menu"
    }, items));
    return output;
  }
}
exports.default = BackHeader;
